import React from 'react';
import PropTypes from 'prop-types';

const NumericInput = (props) => {
    const { name, onChange, value, min, max, isHalfStep, 'data-testid': dataTestId } = props;

    const inputProps = {
        onChange: (e) => {
            return isHalfStep ? onChange(e.target.value) : onChange(parseInt(e.target.value));
        },
        ...(min ? { min } : {}),
        ...(max ? { max } : {}),
        ...(isHalfStep ? { step: 0.5 } : {}),
    };

    return (
        <div className={`row`}>
            <div className={`col-12`}>
                <input
                    type="number"
                    name={name}
                    className={`form-control`}
                    onChange={(e) => onChange(parseInt(e.target.value))}
                    value={value}
                    data-testid={dataTestId}
                    {...inputProps}
                />
            </div>
        </div>
    );
};

NumericInput.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    isHalfStep: PropTypes.bool,
    'data-testid': PropTypes.string,
};

NumericInput.defaultProps = {
    onChange: () => { },
    value: null,
    min: null,
    max: null,
    step: null,
    isHalfStep: false,
    'data-testid': undefined,
};

export default NumericInput;
